import { Input, FormGroup, Table, Label, Col, colg } from "reactstrap"
import { CRUD_PERMS } from "./Constant/constants";
import { formatSubmoduleName,camelCaseToTitle } from "./Constant/common";
import { useSelector } from "react-redux";

export const GenerateModulePermissionsTable = ({ modules, permissionsMap, toggleModule, toggleSubmodule, togglePermission, toggleAllowAllPermission, openSubmodulePopover, setOpenSubmodulePopover }) => {
    const operatorConfiguration = useSelector((state) => state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration)
    const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;

       const roleName=localStorage.getItem("roleName");
    const labelText = isEIPEnabled
        ? ((roleName === "telcoAdmin" || roleName === "telcoOperationUser" || roleName === "telcoBusinessUser") ? "Device Search" : "Device List")
        : ((roleName === "telcoAdmin" || roleName === "telcoOperationUser" || roleName === "telcoBusinessUser") ? "Customer Search" : "Customer List");
    return (
        <>
            <div>
                {modules.map((mod, mIdx) => {
                    return (
                        <div key={mIdx} className="border border-1 p-2 my-4" style={{ overflowX: 'auto' }}>
                            <div className="d-flex justify-content-between">
                                <span className="text-black fw-bold fs-16">{mod.module}</span>
                                <FormGroup switch>
                                    <Input type="switch" checked={mod.isSelected} onChange={() => toggleModule(mIdx)} />
                                </FormGroup>

                            </div>
                            <hr></hr>
                            <Table borderless responsive={true}
                                style={{ tableLayout: 'fixed', minWidth: '700px' }}
                            >
                                <colgroup>
                                    <col style={{ width: '30%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                </colgroup>
                                <thead className="border border-0">
                                    <tr>
                                        <th>

                                        </th>
                                        <th className="text-nowrap">
                                            Allow All
                                        </th>
                                        {CRUD_PERMS.map((perm) => (
                                            <th key={perm}>{perm}</th>
                                        ))}
                                        <th>

                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="border border-0">
                                    {mod?.submodules?.map((sub, sIdx) => {
                                        const allSubModulePermissions = [
                                            ...(permissionsMap.get(
                                                `${mod.module.toLowerCase()}-${sub.submodule.toLowerCase()}`
                                            ) || []),
                                        ];
                                        const otherPermissions = allSubModulePermissions.filter(
                                            (p) => !CRUD_PERMS.includes(camelCaseToTitle(p))
                                        );
                                        const subKey = `${mod.module.toLowerCase()}-${sub.submodule.toLowerCase()}`;
                                        return <tr key={sIdx}>
                                            <td>
                                                <span className="text-black fw-bold fs-16">{sub.name}</span>
                                                <FormGroup switch>
                                                    <Input
                                                        type="switch"
                                                        checked={sub.isSelected}
                                                        disabled={!mod.isSelected}
                                                        onChange={() => toggleSubmodule(mIdx, sIdx)}
                                                    />
                                                    <Label for={`switch-${sIdx}`} className="mb-0 ps-2">{sub.submodule.toLowerCase() === "customer" ? labelText : formatSubmoduleName(sub.submodule)}</Label>
                                                </FormGroup>
                                            </td>
                                            <td>
                                                <Input
                                                    type="checkbox"
                                                    checked={
                                                        sub.permissions.length > 0 &&
                                                        [
                                                            ...(permissionsMap.get(
                                                                `${mod.module.toLowerCase()}-${sub.submodule.toLowerCase()}`
                                                            ) || []),
                                                        ].every((item) => sub.permissions.includes(item.toLowerCase()))
                                                    }
                                                    disabled={!mod.isSelected || !sub.isSelected}
                                                    onChange={(e) =>
                                                        toggleAllowAllPermission(
                                                            mIdx,
                                                            sIdx,
                                                            e.target.checked
                                                        )
                                                    }
                                                /></td>
                                            {CRUD_PERMS.map((perm) => {
                                                return <td key={perm}>
                                                    <Input
                                                        type="checkbox"
                                                        checked={sub.permissions.includes(perm.toLowerCase())}
                                                        disabled={
                                                            !mod.isSelected ||
                                                            !sub.isSelected ||
                                                            ![
                                                                ...(permissionsMap.get(
                                                                    `${mod.module.toLowerCase()}-${sub.submodule.toLowerCase()}`
                                                                ) || []),
                                                            ].includes(perm.toLowerCase())
                                                        }
                                                        onChange={() => togglePermission(mIdx, sIdx, perm.toLowerCase())}
                                                    />
                                                </td>
                                            })}
                                            <td>
                                                {otherPermissions.length > 0 && (
                                                    <>
                                                        <span
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => setOpenSubmodulePopover(subKey)}
                                                        >
                                                            More Options
                                                        </span>

                                                        {openSubmodulePopover === subKey && (
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    right:"30px",
                                                                    background: 'white',
                                                                    border: '1px solid #ccc',
                                                                    padding: '10px',
                                                                    zIndex: 100,
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    minWidth: '150px',
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '5px',
                                                                        right: '5px',
                                                                        cursor: 'pointer',
                                                                        fontWeight: 'bold',
                                                                    }}
                                                                    onClick={() => setOpenSubmodulePopover(null)}
                                                                >
                                                                    X
                                                                </span>

                                                                {otherPermissions.map((perm) => (
                                                                    <label
                                                                        key={perm}
                                                                        style={{
                                                                            display: 'block',
                                                                            marginTop: '5px',
                                                                            textAlign: 'Start',
                                                                        }}
                                                                    >
                                                                        <Input
                                                                            type="checkbox"
                                                                            checked={sub.permissions.includes(perm.toLowerCase())}
                                                                            disabled={
                                                                                !mod.isSelected || !sub.isSelected
                                                                            }
                                                                            onChange={() =>
                                                                                togglePermission(mIdx, sIdx, perm.toLowerCase())
                                                                            }
                                                                        />
                                                                        <span className="mb-0 ps-2">{camelCaseToTitle(perm)}</span>
                                                                    </label>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </td>
                                        </tr>

                                    })}
                                </tbody>
                            </Table>
                        </div>
                    )

                })}
            </div>
        </>
    )
}